<mat-stepper
  orientation="vertical"
  linear
  #stepper
  (selectionChange)="changeWizardStep($event)"
>
  <mat-step>
    <ng-template matStepLabel>{{
      "workorder.employee-visits.date-step" | translate
    }}</ng-template>
    <label class="employee-visits-label">{{
      "workorder.employee-visits.date-start" | translate
    }}</label>
    <div class="calendar-container">
      <input
        class="calendar"
        matInput
        [ngxMatDatetimePicker]="startVisitDatepicker"
        [formControl]="startDateControl"
        (dateChange)="changeCalendarDate()"
        readonly
        [max]="maxStartDate"
      />
      <ngx-mat-datepicker-toggle
        class="calendar-icon"
        matSuffix
        [for]="startVisitDatepicker"
      >
      </ngx-mat-datepicker-toggle>
      <ngx-mat-datetime-picker #startVisitDatepicker [stepMinute]="15">
        <ngx-mat-datepicker-actions>
          <button mat-button ngxMatDatepickerCancel>
            {{ "workorder.employee-visits.cancel" | translate }}
          </button>
          <button mat-button class="calendar-apply" ngxMatDatepickerApply>
            {{ "workorder.employee-visits.apply" | translate }}
          </button>
        </ngx-mat-datepicker-actions>
      </ngx-mat-datetime-picker>
    </div>

    <label class="employee-visits-label">{{
      "workorder.employee-visits.date-end" | translate
    }}</label>
    <div class="calendar-container">
      <input
        class="calendar"
        matInput
        [ngxMatDatetimePicker]="endVisitDatepicker"
        [formControl]="endDateControl"
        (dateChange)="changeCalendarDate()"
        readonly
        [min]="startDateControl.value"
        [max]="maxEndDate"
      />
      <ngx-mat-datepicker-toggle
        class="calendar-icon"
        matSuffix
        [for]="endVisitDatepicker"
      >
      </ngx-mat-datepicker-toggle>
      <ngx-mat-datetime-picker #endVisitDatepicker [stepMinute]="15">
        <ngx-mat-datepicker-actions>
          <button mat-button ngxMatDatepickerCancel>
            {{ "workorder.employee-visits.cancel" | translate }}
          </button>
          <button mat-button class="calendar-apply" ngxMatDatepickerApply>
            {{ "workorder.employee-visits.apply" | translate }}
          </button>
        </ngx-mat-datepicker-actions>
      </ngx-mat-datetime-picker>
    </div>

    <div>
      <button mat-button matStepperPrevious>
        {{ "workorder.employee-visits.back" | translate }}
      </button>
      <button mat-button matStepperNext>
        {{ "workorder.employee-visits.next" | translate }}
      </button>
    </div>
  </mat-step>

  <mat-step [completed]="isSelectEmployeesStepDone">
    <ng-template matStepLabel>
      {{ "workorder.employee-visits.employee-step" | translate }}</ng-template
    >
    <div class="search">
      <input
        #search
        class="search-text"
        type="text"
        placeholder="{{ 'workorder.employee-visits.search' | translate }}"
        [formControl]="searchedEmployeeControl"
        (keyup)="updateSearchTerm(search.value)"
        [matAutocomplete]="auto"
        onClick="this.select();"
      />
      <mat-icon class="search-icon">search</mat-icon>
    </div>
    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displayEmployee"
      autoActiveFirstOption="true"
      (optionSelected)="assignEmployeeToVisit()"
    >
      <ng-container *ngFor="let employee of availableEmployees$ | async">
        <mat-option *ngIf="!isAlreadySelected(employee)" [value]="employee">
          {{ employee.name }}
        </mat-option>
      </ng-container>
    </mat-autocomplete>

    <ul>
      <li
        tabindex="0"
        *ngFor="let employeeVisit of employeeVisits"
        (click)="removeEmployeeVisit(employeeVisit.employeeId)"
        (keyup.enter)="removeEmployeeVisit(employeeVisit.employeeId)"
      >
        {{ employeeVisit.employeeFullName }}
        <mat-icon class="icon">remove</mat-icon>
      </li>
    </ul>

    <div>
      <button mat-button matStepperPrevious>
        {{ "workorder.employee-visits.back" | translate }}
      </button>
      <button mat-button matStepperNext [disabled]="!isSelectEmployeesStepDone">
        {{ "workorder.employee-visits.next" | translate }}
      </button>
    </div>
  </mat-step>

  <mat-step>
    <ng-template matStepLabel>
      {{ "workorder.employee-visits.resume-step" | translate }}</ng-template
    >
    <label class="employee-visits-label"
      ><b>
        {{ startDateControl.value | localizedDate : "d MMMM, y" }}
      </b></label
    >
    <ul>
      <li
        class="resume-container"
        tabindex="0"
        *ngFor="let employeeVisit of employeeVisits"
      >
        <label>{{ employeeVisit.employeeAbbreviatedName }}</label>
        <div class="time-selector">
          <input
            matInput
            type="time"
            [ngModel]="employeeVisit.startDate | date : 'HH:mm'"
            (ngModelChange)="changeEmployeeStartTime($event, employeeVisit)"
            step="900"
          />
          <span class="spacer"></span>
          <input
            matInput
            type="time"
            [ngModel]="employeeVisit.endDate | date : 'HH:mm'"
            (ngModelChange)="changeEmployeeEndTime($event, employeeVisit)"
            step="900"
          />
        </div>
      </li>
    </ul>
    <p class="time-legend" *ngIf="isStartAndEndDateOnDifferentDays">
      {{ "workorder.employee-visits.visit-ends-next-day" | translate }}
    </p>
    <div>
      <button mat-button matStepperPrevious>
        {{ "workorder.employee-visits.back" | translate }}
      </button>
    </div>
  </mat-step>
</mat-stepper>
